import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "md:flex items-center justify-between p-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, "Transaksi Bus Berjalan", -1)
const _hoisted_4 = { class: "w-full md:w-1/3" }
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Tidak ada data ditemukan. ", -1)
const _hoisted_8 = { class: "text-left break-words text-grey font-normal text-base" }
const _hoisted_9 = { class: "text-left break-words text-grey font-normal text-base" }
const _hoisted_10 = { class: "text-left break-words text-grey font-normal text-base" }
const _hoisted_11 = { class: "text-left break-words text-primary font-bold text-base" }
const _hoisted_12 = { class: "text-left break-words text-primary font-bold text-base" }

import { getCurrentInstance, onMounted, ref } from 'vue'
import Card from 'primevue/card'
import moment from 'moment'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ProgressSpinner from 'primevue/progressspinner'
import Paginator from '@/views/components/paginator/Paginator.vue'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import { dataFor } from 'knockout'
import { useStore } from 'vuex'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { useRoute } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'


export default /*#__PURE__*/_defineComponent({
  __name: 'UnclosedTransaction',
  setup(__props) {

const endpoint = 'transaction/v2/Dashboards'
const backRouteName = 'unclosed-transaction'

const store = useStore()
const route = useRoute()
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const inputSearch = ref('')
const idPrams = ref(null) as any
const filters = {
  pageNumber: 1,
  pageSize: 5,
  totalRecords: 0,
  rowPerPageOptions: [5, 10]
}
const isLoading = ref(false)

const dataSource = ref([]) as any

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${endpoint}/transactions/preview/by-trayek/${idPrams.value?.Id}${returnUrlPrams({
    pageNumber: filters.pageNumber,
    pageSize: filters.pageSize,
    filterField: ['q'],
    search: inputSearch.value,
  })}`).then((response) => {
    // console.log('response', response)
    filters.totalRecords = response.count
    dataSource.value = response.result
    // console.log('dataSource', dataSource.value)
    isLoading.value = false
  })
  store.dispatch('hideLoading')
}

const onSearch = (val: any) => {
  // console.log('valsearch', val)
  getData()
}

const onChangePage = ({ page, rows }: any) => {
  console.log('page', page)
  filters.pageSize = rows
  filters.pageNumber = page + 1
  getData()
}

onMounted(() => {
  // initDataSource()
  idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
  getData()

  store.dispatch('ui/setBreadcrumbs', [
    {
      title: 'Master Kota & Terminal',
      routeName: backRouteName
    },
    {
      title: idPrams.value?.TrayekName,
      routeName: `${backRouteName}-detail`
    }
  ])
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "card-no-shadow" }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(InputIconRight, {
                    class: "input-search-header-custom",
                    placeholder: "Cari disini...",
                    modelValue: inputSearch.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputSearch).value = $event)),
                    canClick: true,
                    icon: _unref(icon).svg.searchEva,
                    onSubmitInput: onSearch,
                    onKeyup: _withKeys(onSearch, ["enter"]),
                    disabled: false
                  }, null, 8, ["modelValue", "icon", "onKeyup"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(DataTable), {
                    value: _unref(dataSource),
                    rows: 5,
                    class: "table-og w-full"
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_7
                    ]),
                    loading: _withCtx(() => [
                      _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(Column), {
                        header: "NOMOR BUS",
                        style: {"min-width":"110px"},
                        class: "text-left break-words text-grey font-bold text-sm w-3/12"
                      }, {
                        body: _withCtx((slotProps) => [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(`${slotProps.data.VehicleRegNumber} - ${slotProps.data.VehicleHullNumber}`), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "TransactionDate",
                        header: "TANGGAL PP",
                        style: {"min-width":"110px"},
                        class: "text-left break-words text-grey font-bold text-sm w-3/12"
                      }, {
                        body: _withCtx(({ data, field }) => [
                          _createElementVNode("p", _hoisted_9, _toDisplayString(`${_unref(moment)(data[field]).format('dddd')}, ${_unref(moment)(data[field]).format('DD MMMM YYYY')} - ${_unref(moment)(data[field]).format('HH:mm')}`), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "CondecturName",
                        header: "NAMA KONDEKTUR",
                        style: {"min-width":"110px"},
                        class: "text-left break-words text-grey font-bold text-sm w-2/12"
                      }, {
                        body: _withCtx(({ data, field }) => [
                          _createElementVNode("p", _hoisted_10, _toDisplayString(data[field]), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "TotalTicketCashAmount",
                        header: "PENDAPATAN TUNAI",
                        style: {"min-width":"110px"},
                        class: "text-left break-words text-grey font-bold text-sm w-2/12"
                      }, {
                        body: _withCtx(({ data, field }) => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(currencyNumberFormat)(data[field])), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Column), {
                        field: "TotalTicketNonCashAmount",
                        header: "PENDAPATAN NON TUNAI",
                        style: {"min-width":"110px"},
                        class: "text-left break-words text-grey font-bold text-sm w-2/12"
                      }, {
                        body: _withCtx(({ data, field }) => [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(currencyNumberFormat)(data[field])), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ])
              ]),
              (filters.totalRecords > 0)
                ? (_openBlock(), _createBlock(Paginator, {
                    key: 0,
                    rows: filters.pageSize,
                    totalRecords: filters.totalRecords,
                    onOnPage: onChangePage,
                    rowsPerPageOptions: filters.rowPerPageOptions
                  }, null, 8, ["rows", "totalRecords", "rowsPerPageOptions"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})